'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { Button } from '@/components/ui/button';

export function HeaderPublic() {
  const t = useTranslations('header.public');
  const tCommon = useTranslations('common');

  return (
    <header
      className="bg-background flex items-center justify-between border-b p-4"
      data-testid="header-public"
    >
      <div className="flex items-center gap-6">
        <Link
          href="/en"
          className="text-lg font-semibold transition-opacity hover:opacity-80"
        >
          {t('title')}
        </Link>
        <nav
          className="hidden items-center gap-4 md:flex"
          aria-label={t('nav.ariaLabel')}
        >
          <Link
            href="/en"
            className="focus-ring-keyboard-only rounded-sm px-1 text-sm hover:underline"
          >
            {t('nav.home')}
          </Link>
        </nav>
      </div>
      <div className="flex items-center gap-3">
        <Button variant="ghost" asChild>
          <Link href="/en/login" className="focus-ring-keyboard-only">
            {tCommon('signIn')}
          </Link>
        </Button>
        <Button asChild>
          <Link href="/en/register" className="focus-ring-keyboard-only">
            {tCommon('register')}
          </Link>
        </Button>
      </div>
    </header>
  );
}
